import { noop } from "lodash";
import type { Paywall } from "@/react/types";
import { usePaywallApi } from "@circle-react/components/Paywalls/Admin/PaywallsAdmin/hooks/usePaywallApi";

interface PaywallActionsProps {
  paywall: Partial<Paywall>;
  refetchPaywalls: () => void;
}

export const usePaywallActions = ({
  paywall,
  refetchPaywalls,
}: PaywallActionsProps) => {
  const { publishMutation, archiveMutation, deleteMutation } = usePaywallApi({
    createCallback: noop,
    updateCallback: refetchPaywalls,
    paywall,
  });

  const publishPaywall = () => publishMutation.mutate();

  const archivePaywall = () => archiveMutation.mutate();

  const deletePaywall = () => deleteMutation.mutate();

  return {
    publishPaywall,
    archivePaywall,
    deletePaywall,
  };
};
